import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["modal", "amountInput", "message"]

    connect() {
        this.modalTarget.classList.add("hidden")
    }

    open(event) {
        const amount = event.currentTarget.dataset.amount
        this.amountInputTarget.value = amount
        this.messageTarget.textContent = `Записать ${amount} рейка?`
        this.modalTarget.classList.remove("hidden")
    }

    close(event) {
        if (event) event.preventDefault()
        this.modalTarget.classList.add("hidden")
    }
}
